export enum AuthFlowActionTypes {
  SetAuthStep = 'SET_AUTH_STEP',
  SetAuthFLowParams = 'SET_AUTH_FLOW_PARAMS',
  SetStatus = 'SET_STATUS',
  SetSepScrAuth = 'SET_SEP_SCR_AUTH',
  SetInitAuthState = 'SET_INIT_AUTH_STATE',
}
